<template>
  <v-dialog
    retain-focus
    :value="edit"
    v-on:click:outside="goToShow"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title tabindex="-1">
        <span class="headline">Edit User</span>
        <v-btn
          style="position: absolute; top: 0; right: 0;"
          @click="goToShow"
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-on:submit.prevent width="100%" ref="createForm" v-model="createValid">
          <v-text-field
            :rules="validationRules.name"
            v-model="editFields.name"
            label="Name*"
            required
            :error-messages="inputErrorMessages('name')"
            v-on:keyup.enter="saveUser"
            ref="name"
            tabindex="0"
          />
          <v-text-field
            :rules="validationRules.email"
            v-model="editFields.email"
            label="Email Address*"
            required
            :error-messages="inputErrorMessages('email')"
            v-on:keyup.enter="saveUser"
            ref="email"
            tabindex="1"
          />
          <v-text-field
            :rules="validationRules.password"
            v-model="editFields.password"
            label="Password*"
            required
            :error-messages="inputErrorMessages('password')"
            :type="'password'"
            v-on:keyup.enter="saveUser"
            ref="password"
            tabindex="1"
          />
          <v-text-field
            :rules="[editFields.password === editFields.confirmpassword || 'Password must match']"
            v-model="editFields.confirmpassword"
            label="Confirm Password"
            required
            :error-messages="inputErrorMessages('confirmpassword')"
            :type="'password'"
            v-on:keyup.enter="saveUser"
            ref="confirmpassword"
            tabindex="1"
          />
        </v-form>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="goToShow">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="saveUser">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      addSpecError: undefined,
      continousCreation: false,
      createValid: true,
      validationRules: {
        name: [
          v => !!v || this.rem('Name'),
          v => v.length <= 255 || 'Name should not be greater than 255'
        ],
        email: [
          v => !!v || this.rem('Email address'),
          v => !v || /.+@.+/.test(v) || 'Email address must be valid'
        ],
        password: [
          v => !!v || this.rem('Password'),
          v => !v || v.length <= 10 || 'Password should not be greater than 10',
          v => !v || v.length >= 5 || 'Password should not be less than 5'
        ]
      },
      errorMessages: {},
      editFields: {
        name: '',
        email: '',
        password: '',
        confirmpassword: ''
      }
    };
  },
  computed: {
    ...mapState({
      user(state) {
        if (typeof state.User.user.data == 'undefined') {
          return {
            name: '',
            email: '',
            password: '',
            confirmpassword: ''
          };
        }
        return state.User.user.data;
      }
    })
  },
  watch: {
    user(value) {
      this.editFields.name = value.name;
      this.editFields.email = value.email;
      this.editFields.password = '';
      this.editFields.confirmpassword = '';
    }
  },
  mounted() {
    this['User/getUser']({ id: this.$route.params.id });
  },
  props: {
    edit: false,
    page: 0
  },
  methods: {
    ...mapActions(['User/fetchUsers', 'User/getUser']),
    clearCreate() {},
    rem(name) {
      return `${name} is required`;
    },
    rem(email) {
      return `${email} is required`;
    },
    rem(password) {
      return `${password} is required`;
    },
    rem(confirmpassword) {
      return `${confirmpassword} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveUser() {
      if (this.$refs.createForm.validate()) {
        axios
          .put(`api/v1/user/${this.$route.params.id}`, this.editFields)
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'User saved...',
              color: 'success'
            });
            this.errorMessages = [];
            this.$refs.createForm.resetValidation();
            this['User/fetchUsers']({ page: this.page });
            this.$router.push('/user');
          })
          .catch(error => {
            if (error.response.status == 403) {
              this.$store.commit('SET_SNACK_BAR', {
                message: error.response.data['message'],
                color: 'error'
              });
            } else {
              this.errorMessages = error.response.data.errors;
            }
          })
          .finally(() => {});
      }
    },
    goToShow() {
      this.$router.push(`/user/${this.$route.params.id}`);
    }
  }
};
</script>